import { useLocalStorageManager } from '@0x234/common-vue/composables/local-storage-manager';
import { defineStore } from 'pinia';
import { Dark } from 'quasar';
import { ref, watchEffect } from 'vue';

export const useAppStore = defineStore('app', () => {
    const localStorageManager = useLocalStorageManager();

    const darkMode = localStorageManager.storeRef('app/darkMode', 'auto');

    const newVersionServiceDialog = ref(null);
    const unavailableServiceDialog = ref(null);

    Dark.set(false); // Force light mode, for now, as there's a few small bugs to address with SSR.

    function _toggleColorSchemeMetaTag() {
        if (!process.env.CLIENT) {
            return;
        }
        const metaTag = document.querySelector('meta[name="color-scheme"]');
        if (Dark.isActive && !metaTag) {
            const meta = document.createElement('meta');
            meta.name = 'color-scheme';
            meta.content = 'dark';
            document.head.appendChild(meta);
        } else if (!Dark.isActive && metaTag) {
            metaTag.remove();
        }
    }

    watchEffect(() => {
        darkMode.value = Dark.mode;
        _toggleColorSchemeMetaTag();
    });

    return {
        darkMode,
        newVersionServiceDialog,
        unavailableServiceDialog
    };
}, {
    preventHydrate: [
        'darkMode',
        'newVersionServiceDialog',
        'unavailableServiceDialog'
    ]
});
